const marketMetroData = [
  {id: 1, market_code: 'MARKET_CODE_ATL', metro_code: 'ATL'},
  {id: 2, market_code: 'MARKET_CODE_AUS', metro_code: 'AUS'},
  {id: 3, market_code: 'MARKET_CODE_NSV', metro_code: 'BNA'},
  {id: 4, market_code: 'MARKET_CODE_CLT', metro_code: 'CLT'},
  {id: 5, market_code: 'MARKET_CODE_HSV', metro_code: 'HSV'},
  {id: 6, market_code: 'MARKET_CODE_OC', metro_code: 'IRV'},
  {id: 7, market_code: 'MARKET_CODE_KC', metro_code: 'MCI'},
  {id: 8, market_code: 'MARKET_CODE_PRV', metro_code: 'PVU'},
  {id: 9, market_code: 'MARKET_CODE_TRI', metro_code: 'RDU'},
  {id: 10, market_code: 'MARKET_CODE_SAT', metro_code: 'SAT'},
  {id: 11, market_code: 'MARKET_CODE_SLC', metro_code: 'SDF'},
  {id: 12, market_code: 'MARKET_CODE_DSM', metro_code: 'SLC'},
  {id: 13, market_code: 'MARKET_CODE_WDM', metro_code: 'DSM'},
  {id: 14, market_code: 'MARKET_CODE_CS', metro_code: 'COS'},
  {id: 15, market_code: 'MARKET_CODE_MRC', metro_code: 'PHX'},
  {id: 16, market_code: 'MARKET_CODE_COU', metro_code: 'COU'},
  {id: 17, market_code: 'MARKET_CODE_BOI', metro_code: 'BOI'},
  {id: 18, market_code: 'MARKET_CODE_OMA', metro_code: 'OMA'},
  {id: 19, market_code: 'MARKET_CODE_DEN', metro_code: 'DEN'},
  {id: 20, market_code: 'MARKET_CODE_LAS', metro_code: 'LAS'},
  {id: 21, market_code: 'MARKET_CODE_STP', metro_code: 'MSP'},
  {id: 22, market_code: 'MARKET_CODE_TUS', metro_code: 'TUS'},
  {id: 23, market_code: 'MARKET_CODE_BTV', metro_code: 'BTV'},
  {id: 24, market_code: 'MARKET_CODE_SGU', metro_code: 'SGU'},
  {id: 25, market_code: 'MARKET_CODE_LGU', metro_code: 'LGU'},
  {id: 26, market_code: 'MARKET_CODE_MHK', metro_code: 'MHK'},
  {id: 27, market_code: 'MARKET_CODE_JEF', metro_code: 'JEF'},
  {id: 28, market_code: 'MARKET_CODE_SEA', metro_code: 'SEA'},
  {id: 29, market_code: 'MARKET_CODE_IDA', metro_code: 'IDA'},
  {id: 30, market_code: 'MARKET_CODE_GRK', metro_code: 'GRK'},
  {id: 31, market_code: 'MARKET_CODE_PIH', metro_code: 'PIH'},
  {id: 32, market_code: 'MARKET_CODE_TWF', metro_code: 'TWF'},
  {id: 33, market_code: 'MARKET_CODE_AIK', metro_code: 'AIK'},
  {id: 33, market_code: 'MARKET_CODE_AUG', metro_code: 'AIK'},
  {id: 34, market_code: 'MARKET_CODE_RAD', metro_code: 'GSO'},
  {id: 35, market_code: 'MARKET_CODE_GSP', metro_code: 'GSP'},
  {id: 36, market_code: 'MARKET_CODE_WIL', metro_code: 'ILM'},
  {id: 37, market_code: 'MARKET_CODE_SD', metro_code: 'SAN'},
  {id: 38, market_code: 'MARKET_CODE_ABQ', metro_code: 'ABQ'},
  {id: 39, market_code: 'MARKET_CODE_VB', metro_code: 'ORF'},
  {id: 40, market_code: 'MARKET_CODE_CHS', metro_code: 'CHS'},
  {id: 41, market_code: 'MARKET_CODE_FLG', metro_code: 'FLG'},
  {id: 42, market_code: 'MARKET_CODE_PRC', metro_code: 'PRC'},
  {id: 43, market_code: 'MARKET_CODE_SVL', metro_code: 'SFO'},
];
export const getMetroCodeByMarketCode = (marketCode = '') =>
  marketMetroData?.find(row => row.market_code === marketCode)?.metro_code;
